/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CheckEmailRequest } from '../models/CheckEmailRequest';
import type { CheckEmailResponse } from '../models/CheckEmailResponse';
import type { PageableUsersResponse } from '../models/PageableUsersResponse';

import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';

export class UserApi {

  constructor(public readonly httpRequest: BaseHttpRequest) {}

  /**
   * Get all users
   * @param limit
   * @param offset
   * @param search
   * @param type
   * @param isPublic
   * @returns PageableUsersResponse Get users response
   * @throws ApiError
   */
  public getUsers(
    limit?: (number | string),
    offset?: (number | string),
    search?: string,
    type?: string,
    isPublic?: string,
  ): CancelablePromise<PageableUsersResponse> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/users',
      query: {
        'limit': limit,
        'offset': offset,
        'search': search,
        'type': type,
        'isPublic': isPublic,
      },
      errors: {
        400: `Bad request`,
        401: `Unauthorized`,
        403: `Forbidden`,
        404: `Not found`,
        422: `Validation error`,
        500: `Something went wrong`,
      },
    });
  }

  /**
   * Get all codebook users
   * @param limit
   * @param offset
   * @param search
   * @param type
   * @param isPublic
   * @returns PageableUsersResponse Get users response
   * @throws ApiError
   */
  public getWarehouseUsers(
    limit?: (number | string),
    offset?: (number | string),
    search?: string,
    type?: string,
    isPublic?: string,
  ): CancelablePromise<PageableUsersResponse> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/codebook/users',
      query: {
        'limit': limit,
        'offset': offset,
        'search': search,
        'type': type,
        'isPublic': isPublic,
      },
      errors: {
        400: `Bad request`,
        401: `Unauthorized`,
        403: `Forbidden`,
        404: `Not found`,
        422: `Validation error`,
        500: `Something went wrong`,
      },
    });
  }

  /**
   * Delete user by id
   * @param id
   * @returns any Deleted user
   * @throws ApiError
   */
  public deleteUserById(
    id: string,
  ): CancelablePromise<any> {
    return this.httpRequest.request({
      method: 'DELETE',
      url: '/users/{id}',
      path: {
        'id': id,
      },
      errors: {
        400: `Bad request`,
        401: `Unauthorized`,
        403: `Forbidden`,
        404: `Not found`,
        422: `Validation error`,
        500: `Something went wrong`,
      },
    });
  }

  /**
   * Check email address
   * @param requestBody Check email body schema
   * @returns CheckEmailResponse Email checked
   * @throws ApiError
   */
  public checkEmail(
    requestBody?: CheckEmailRequest,
  ): CancelablePromise<CheckEmailResponse> {
    return this.httpRequest.request({
      method: 'PATCH',
      url: '/users/email',
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        401: `Unauthorized`,
        500: `Something went wrong`,
      },
    });
  }

}
